import { useState } from 'react'
import { Show } from 'react-admin'
import { useNavigate } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { EquipeViewForm } from './equipe'
import { AccesViewForm } from './access'
import { EquipementViewForm } from './equipement'
import { DocumentsViewForm } from './document'
import { InformationsImportant } from './InfosImportant'
import { InfosComplementary } from './InfosComplementary'

export const CoproFicheExtView = (props) => {
  const navigate = useNavigate()
  const [collapsed, setCollapsed] = useState([])
  const useStyles = makeStyles(() => ({
    root: {
      height: '100%',
      '@global': {
        '.RaShow-main': {},
      },
    },
    rootCollapse: {
      height: '100%',
      '@global': {
        '.RaShow-main': {},
      },
    },
    beginBar: {
      position: 'absolute',
      height: '100%',
      width: '4.5px',
      background: '#e4e6ef',
      top: 0,
      left: 0,
      borderRadius: '10px',
    },
    MuiListItemTextMultiline: {
      marginTop: 0,
      marginBottom: 0,
    },
    MuiListItemRoot: {
      position: 'relative',
      padding: '5px 15px',
      marginLeft: '10px',
      marginBottom: '20px',
    },
    titleCard: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingRight: '10px',
      cursor: 'pointer',
      boxShadow: '1px 1px 12px 1px #183a6024',
      background: '#f6f6f6bf',
    },
    noMarginRaAction: {
      '& > .RaShow-noActions': {
        marginTop: 0,
      },
    },
  }))
  const classes = useStyles()
  return (
    <>
      <Show
        {...props}
        title=" "
        actions={false}
        className={classes.noMarginRaAction}
      >
        <InformationsImportant {...props} />
      </Show>
      <Show
        {...props}
        title=" "
        actions={false}
        className={classes.noMarginRaAction}
      >
        <EquipeViewForm {...props} />
      </Show>
      <Show
        {...props}
        title=" "
        actions={false}
        className={classes.noMarginRaAction}
      >
        <InfosComplementary {...props} />
      </Show>
      {/* We do not display this information temporarily "Acces" et  "equipements" */}
      {/* <Show {...props} title=" " actions={false}>
        <AccesViewForm {...props} />
      </Show>
      <Show {...props} title=" " actions={false}>
        <EquipementViewForm {...props} />
      </Show> */}
    </>
  )
}
